import env from '@/env';
export default {
  install: function install(Vue) {
    Vue.prototype.$env = env;
  }
};